import { render, staticRenderFns } from "./wechatBinding.vue?vue&type=template&id=7ecb1578&scoped=true"
import script from "./wechatBinding.vue?vue&type=script&lang=js"
export * from "./wechatBinding.vue?vue&type=script&lang=js"
import style0 from "./wechatBinding.vue?vue&type=style&index=0&id=7ecb1578&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecb1578",
  null
  
)

export default component.exports